class FaqClass {
  init() {
    const faqSection = document.querySelector("[data-component='faq']");
    
    // Если секция FAQ не найдена на странице, выходим
    if (!faqSection) {
      return;
    }
    
    // Проверяем, не был ли компонент уже инициализирован
    if (faqSection.dataset.faqInitialized) {
      return;
    }

    const faqItems = faqSection.querySelectorAll(".faq__item");

    // Первичная инициализация - сбрасываем все состояния
    faqItems.forEach((item) => {
      const answer = item.querySelector(".faq__item-content");
      const openIcon = item.querySelector(".faq__item__open-icon");
      const closeIcon = item.querySelector(".faq__item__close-icon");

      // Гарантируем, что все блоки изначально закрыты
      item.classList.remove("active");
      answer.style.maxHeight = "0px";
      answer.style.paddingTop = "0px";
      openIcon.style.display = "block";
      closeIcon.style.display = "none";
    });

    // Добавляем обработчики событий
    faqItems.forEach((item) => {
      const question = item.querySelector(".faq__item-header");
      const answer = item.querySelector(".faq__item-content");
      const openIcon = item.querySelector(".faq__item__open-icon");
      const closeIcon = item.querySelector(".faq__item__close-icon");

      item.addEventListener("click", function () {
        // Закрываем другие элементы
        faqItems.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("active")) {
            const otherAnswer = otherItem.querySelector(".faq__item-content");
            const otherOpenIcon = otherItem.querySelector(
              ".faq__item__open-icon"
            );
            const otherCloseIcon = otherItem.querySelector(
              ".faq__item__close-icon"
            );

            otherAnswer.style.maxHeight = "0px";
            otherAnswer.style.paddingTop = "0px";
            otherItem.classList.remove("active");
            otherOpenIcon.style.display = "block";
            otherCloseIcon.style.display = "none";
          }
        });

        // Переключаем текущий элемент
        if (item.classList.contains("active")) {
          answer.style.maxHeight = "0px";
          answer.style.paddingTop = "0px";
          item.classList.remove("active");
          openIcon.style.display = "block";
          closeIcon.style.display = "none";

          item.setAttribute("aria-expanded", false);
        } else {
          // Временно показываем контент для расчета высоты
          answer.style.display = "block";
          answer.style.maxHeight = "none";
          answer.style.paddingTop = "12px"; // Устанавливаем будущий паддинг

          // Получаем полную высоту контента с паддингом
          const contentHeight = answer.scrollHeight;

          // Сбрасываем стили обратно
          answer.style.display = "";
          answer.style.maxHeight = "0px";
          answer.style.paddingTop = "0px";

          // Устанавливаем финальную высоту с анимацией
          setTimeout(() => {
            answer.style.maxHeight = contentHeight + 12 + "px";
            answer.style.paddingTop = "12px";
          }, 10);

          item.classList.add("active");
          item.setAttribute("aria-expanded", true);
          openIcon.style.display = "none";
          closeIcon.style.display = "block";
        }
      });

      // Обработчик изменения размера окна для корректировки высоты
      window.addEventListener("resize", () => {
        if (item.classList.contains("active")) {
          // Пересчитываем высоту при изменении размера окна
          answer.style.maxHeight = "none";
          answer.style.paddingTop = "12px";
          const contentHeight = answer.scrollHeight;
          answer.style.maxHeight = contentHeight + "px";
        }
      });
    });

    // Помечаем компонент как инициализированный
    faqSection.dataset.faqInitialized = "true";
  }
}

export const Faq = new FaqClass();